import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

// project-imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { queryClient } from 'services/queryClient';

import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth & authorization
import { AuthProvider } from 'contexts/AuthContext';
import { AbilityContext } from 'contexts/AbilityContext';
import useAuth from 'hooks/useAuth';

// ==============================|| ABILITY WRAPPER ||============================== //

function AbilityWrapper({ children }: { children: React.ReactNode }) {
  const { ability } = useAuth();
  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <AbilityWrapper>
              <QueryClientProvider client={queryClient}>
                <Notistack>
                  <RouterProvider router={router} />
                  <Snackbar />
                </Notistack>
              </QueryClientProvider>
            </AbilityWrapper>
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
}
